// React import not needed with new JSX transform
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LandingPage from './pages/LandingPage';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import Dashboard from './pages/Dashboard';
import PublicProfile from './pages/PublicProfile';
import VerifyOtp from './pages/VerifyOtp';
import { AuthProvider } from './contexts/AuthContext';
import { ConfigProvider } from './contexts/ConfigContext';

// Redirect /connect/:profileUrl to /:profileUrl for backward compatibility
const ConnectRedirect = () => {
  const { profileUrl } = useParams();
  return <Navigate to={`/${profileUrl ?? ''}`} replace />;
};

// Redirect legacy routes to root level
const LegacyProfileRedirect = () => {
  const { profileUrl } = useParams();
  return <Navigate to={`/${profileUrl ?? ''}`} replace />;
};

function App() {
  return (
    <AuthProvider>
      <ConfigProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/verify-otp" element={<VerifyOtp />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/dashboard/*" element={<Dashboard />} />
              {/* Redirect /connect/:profileUrl to /:profileUrl for backward compatibility */}
              <Route path="/connect/:profileUrl" element={<ConnectRedirect />} />
              <Route path="/user/:profileUrl" element={<LegacyProfileRedirect />} />
              <Route path="/u/:profileUrl" element={<LegacyProfileRedirect />} />
              {/* Root-level public profile route */}
              <Route path="/:profileUrl" element={<PublicProfile />} />
            </Routes>
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: '#4ade80',
                    secondary: '#fff',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
          </div>
        </Router>
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
